import * as React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';



export function convertJSON2REACT(json: any, modePDF?: boolean, listOption?: any) {
    const node = json.node;
    const tag = json.tag;
    const list = tag === 'ul' || tag === 'ol' ? true : false;
    const style = json.attr && json.attr.style ? json.attr.style : [];
    const styleReact = convertStyle(style, tag, modePDF);
    // console.log('convertJSON2REACT', json);
    const ulStyle = {
        width: '3px',
        height: '3px',
        backgroundColor: 'black',
        borderRadius: '50',
        margin: '2px'
    };

    if (node === 'root') {

        if (modePDF) {
        return <View
            style={styleReact}
        >
            {json.child && json.child.map((c: any) => convertJSON2REACT(c, true))}
        </View>;
        }

        return (
            <div
            style={styleReact} >
            {json.child && json.child.map((c: any) => convertJSON2REACT(c, true))}
        </div>
        );
    }
    if (node === 'element' && tag !== 'img' && !list && tag !== 'li') {

        if (modePDF) {
        return <View
                style={styleReact}
            >
            {json.child && json.child.map((c: any) => convertJSON2REACT(c, true))}
        </View>;
        }
        return (
            <div
                style={styleReact}
            >
            {json.child && json.child.map((c: any) => convertJSON2REACT(c, true))}
        </div>
        );
    }
    if (node === 'text') {
        if (modePDF) {
            if (json.text.length > 0 && json.text !== '&nbsp;') {
                return <Text>{json.text}</Text>;
            }
            return null;
        }
        return json.text;
    }

    if (node === 'element' && tag === 'img' && modePDF) {
            const imgStyle = {width: json.attr.width, height: json.attr.height};
            return  <Image src = {json.attr.src} style={imgStyle}/>;
    }

    if (node === 'element' && modePDF && list) {
        const listElement = json.child.filter((e: any) => e.tag === 'li');
        return (
            <View>
                 {listElement.map((c: any, idx: number) => convertJSON2REACT(c, true, {type: tag, pos: idx + 1}))}
            </View>
        );
    }

    if (node === 'element' && tag === 'li' && modePDF) {
            return(
                <View style={{display: 'flex', flexDirection: 'row'}}>
                    {listOption && listOption.type === 'ol' &&
                        <Text style={{marginRight: '4px'}}>{listOption.pos + '.'}</Text>
                    }
                    {listOption && listOption.type === 'ul' &&
                        <View style={ulStyle}></View>
                    }
                    {json.child && json.child.map((c: any) => convertJSON2REACT(c, true, listOption))}
                </View>
            );
    }



    function convertStyle(css: Array<any>, nodeTag?: string, pdf?: boolean) {
        let styleNew: any = {};
        for (let i = 0; i < css.length; i += 2) {    // 2er-Schritte

            const wert = css[i].replace(':', '');
            const objWert: any = {};

            if (wert.indexOf('-') !== -1) {
                const pos = wert.indexOf('-');
                const t = wert.replace('-', '')
                    .replace('fontweight', '');
                const text = t.slice(0, pos) + t.charAt(pos).toUpperCase() + t.slice(pos + 1);
                objWert[text.replace(/^\s+/g, '')] = css[i + 1].replace('px solid', ' solid')
                    .replace('bold', '')
                    .replace(';', '')
                    .replace(/^\s+/g, '');
            } else {
                objWert[wert.replace(/^\s+/g, '')] = css[i + 1].replace('px solid', ' solid')
                    .replace('bold', '')
                    .replace(/^\s+/g, '');
            }
            styleNew = {...objWert};

        }
        if (nodeTag && nodeTag === 'strong') {
            if (pdf) {
                styleNew.fontFamily = 'Helvetica-Bold';
            }
            styleNew.fontWeight = 'bold';
        }
        if (nodeTag && nodeTag === 'em') {
            if (pdf) {
                styleNew.fontFamily = 'Helvetica-Oblique';
            }
            styleNew.fontStyle = 'italic';
        }
        return styleNew;
    }

}
